import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-ink-900" data-id="element-172" data-mp="3krp5n656qzqv">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" style={{
      paddingTop: "17px",
      paddingBottom: "12px"
    }} data-id="element-173" data-mp="3fz5mltnqbceo">
        <h2 id="testimonios" className="text-center font-display text-2xl uppercase text-white sm:text-3xl" data-id="element-174" data-mp="3b01hpf7u80u5">
          LO QUE DICEN LOS MONITORES QUE YA LO USAN
        </h2>

        <ul className="mt-10 grid gap-6 lg:grid-cols-3" data-id="element-175" data-mp="31zmrc1g0nvjs">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded-2xl border border-ink-600 bg-ink-800 p-6" data-id="element-176" data-mp="2x09yn02gru9a">
              <div className="flex gap-1" aria-label="5 de 5 estrellas" data-id="element-177" data-mp="2s2rvxrf1ib9q">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-ball-400 text-ball-400" aria-hidden="true" data-id="element-178" data-mp="v72jbqmupcne" data-mpi={index} />)}
              </div>
              <blockquote className="mt-5 text-[15px] leading-relaxed text-slate-200" data-id="element-179" data-mp="h5f0vqsro53b">
                “{testimonial.quote}”
              </blockquote>
              <footer className="mt-auto pt-6 text-sm font-semibold text-court-200" data-id="element-180" data-mp="m6cio29v6x4a">
                {testimonial.name} <span className="text-slate-500" data-id="element-181" data-mp="79v6j8tupego">— {testimonial.country}</span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}